export class TabName {
  process: Array<object> = [
    {
      name: " 代办",
      icon: "icon-daiban"
    },
    {
      name: "已办",
      icon: "icon-finished"
    },
    {
      name: "我提交的流程",
      icon: "icon-liucheng"
    }
  ];
  news: Array<object> = [
    {
      name: " 公司新闻",
      icon: "icon-xinwen"
    },
    {
      name: "通知公告",
      icon: "icon-laba"
    }
  ];
}

export class News {
  data1: Array<object> = [
    {
      key: "1",
      content: `[ 未审 ] 赵丽萍借支: 单据编号-100000077 请审核`,
      date: `2017-11-11`
    },
    {
      key: "2",
      content: `[ 未审 ] 赵丽萍借支: 单据编号-100000077 请审核`,
      date: `2017-11-11`
    },
    {
      key: "3",
      content: `[ 未审 ] 赵丽萍借支: 单据编号-100000077 请审核`,
      date: `2017-11-11`
    },
    {
      key: "4",
      content: `[ 未审 ] 赵丽萍借支: 单据编号-100000077 请审核`,
      date: `2017-11-11`
    },
    {
      key: "5",
      content: `[ 未审 ] 赵丽萍借支: 单据编号-100000077 请审核`,
      date: `2017-11-11`
    }
  ];
  data2: Array<object> = [
    {
      key: "1",
      content: `澳优受邀参加中国食品安全年会`,
      date: `2017-11-11`
    },
    {
      key: "2",
      content: `澳优受邀参加中国食品安全年会`,
      date: `2017-11-11`
    },
    {
      key: "3",
      content: `澳优受邀参加中国食品安全年会`,
      date: `2017-11-11`
    }, {
      key: "4",
      content: `澳优受邀参加中国食品安全年会`,
      date: `2017-11-11`
    }, {
      key: "5",
      content: `澳优受邀参加中国食品安全年会`,
      date: `2017-11-11`
    }, {
      key: "6",
      content: `澳优受邀参加中国食品安全年会`,
      date: `2017-11-11`
    }, {
      key: "7",
      content: `澳优受邀参加中国食品安全年会`,
      date: `2017-11-11`
    }, {
      key: "8",
      content: `澳优受邀参加中国食品安全年会`,
      date: `2017-11-11`
    }
  ];
}

export class News2 {}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/class.ts